export default "__VITE_ASSET__B4vdVPVU__"